import React, { useState } from 'react';
import ColumnReviewsList from "./ColumnReviewsList";
import useReviews from "./UseReviews";

export default function CarReviews(props) {

    const reviews = useReviews(props);
    const displayTitle = 'Reviews for '+(props.item.year + ' ' + props.item.title.split(' ').slice(0, 2).join(' '));

    if (reviews) {
        props.handleReviews(reviews);
    }

    return (
        <ColumnReviewsList displayTitle={displayTitle} reviews={reviews}
                           setReturnToItemRoute={props.setReturnToItemRoute}
                           handleSubmitReview={props.handleSubmitReview}
                           noReviewsMessage={'Did you drive this car? What was your experience? What is your rating?\n' +
            'Submit your review and help our visitors to make a good choice.'}/>
    );
}
